"use client";

import { useLocale } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";
import { useTransition } from "react";

export function LanguageSwitcher() {
	const locale = useLocale();
	const pathname = usePathname();
	const router = useRouter();
	const [isPending, startTransition] = useTransition();
	const other = locale === "ru" ? "en" : "ru";

	return (
		<button
			type="button"
			onClick={() => startTransition(() => router.replace(pathname, { locale: other }))}
			className="flex min-h-[2.25rem] items-center gap-1 rounded-md border px-3 font-medium text-sm transition-colors hover:bg-accent disabled:opacity-50"
			aria-label={other === "ru" ? "Переключить на русский" : "Switch to English"}
			disabled={isPending}
		>
			{other.toUpperCase()}
		</button>
	);
}
